<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center" mt-5>
        <h1 class="display-3	font-weight-black">Авторизация</h1>
      </v-flex>
      <v-flex xs12 class="text-xs-center page_inner__description" mt-3>
        <p>Для авторизации введите свой мобильный номер, на который вам прийдет СМС-сообщение с кодом</p>
      </v-flex>
      <v-flex xs12 sm6 offset-sm3 mt-3>
        <v-form validation>
          <v-layout column>
            <v-layout >
              <v-flex>
                <v-text-field
                  name="number"
                  label="Введите номер телефона"
                  id="number"
                  type="number"
                  placeholder="XX - XXX - XX - XX"
                  v-model="phNo"
                  required
                  :counter="9"

                >
                </v-text-field>
              </v-flex>
              <v-flex class="text-xs-center" mt-5>
                <v-btn
                  class="a_btn_accept"
                  @click="sendOtp"
                  >Отправить
                </v-btn>
              </v-flex>
          </v-layout>

            <div id="recaptcha-container"></div><br>
            <v-flex xs12 class="text-xs-center page_inner__description" mt-3>Ниже введите СМС-сообщение с кодом</p></v-flex>

          <v-layout >
            <v-flex>
              <v-text-field
                name="Пароль"
                label="Введите пароль из СМС"
                id="otp"
                type="number"
                placeholder="* * * * * *"
                v-model="otp"
                required
                :counter="6"

                >
              </v-text-field>
            </v-flex>
            <v-flex class="text-xs-center" mt-5>
              <v-btn
                class="a_btn_accept"
                @click="verifyOtp"
                >Войти
              </v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-form>
    </v-flex>
  </v-layout>
  <div>
    <br>
      <button @click="sendOtp()" style="color: #ff3700">Повторно отправить код</button>
  </div>
  </v-container>

</template>

<script>
  import firebase from 'firebase'
  export default {
    data(){
      return{
        phNo: '',
        appVerifier: '',
        otp : '',
        valid: false,
        numberRules: [
          v => (v && v.length >= 9) || 'Номер должен быть 9-ти значным'
        ],
        otpRules: [
          v => (v && v.length >= 6) || 'Код должен быть 6-ти значным'
        ]
      }
    },
    methods :{
      sendOtp(){
        if(this.phNo.length != 9){
          alert('Заполните поле номера телефона !');
        }else{
          //
          let countryCode = '+380'
          let phoneNumber = countryCode + this.phNo
          //
          let appVerifier = this.appVerifier
          //
          firebase.auth().signInWithPhoneNumber(phoneNumber, appVerifier)
            .then(function (confirmationResult) {
              // SMS sent. Prompt user to type the code from the message, then sign the
              // user in with confirmationResult.confirm(code).
              window.confirmationResult = confirmationResult;
              //
              alert('Код отправлен')
            }).catch(function (error) {
            // Error; SMS not sent
            // ...
            alert('Ошибка! Код не оправлен')
          });
        }
      },
      //
      verifyOtp(){
        if(this.phNo.length != 9 || this.otp.length != 6){
          alert('некорректный номер телефона/код!');
        }else{
          //
          let vm = this
          let code = this.otp
          //
          window.confirmationResult.confirm(code).then(function (result) {
            // User signed in successfully.
            var user = result.user;
            // ...
            //route to set password !
            vm.$router.push({path:'/meetups'})
          }).catch(function (error) {
            // User couldn't sign in (bad verification code?)
            // ...
          });
        }
      },
      initReCaptcha(){
        setTimeout(()=>{
          let vm = this
          window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
            'size': 'invisible',
            'callback': function(response) {
              // reCAPTCHA solved, allow signInWithPhoneNumber.
              // ...
            },
            'expired-callback': function() {
              // Response expired. Ask user to solve reCAPTCHA again.
              // ...
            }
          });
          //
          this.appVerifier =  window.recaptchaVerifier
        },1000)
      }
    },
    created(){
      this.initReCaptcha()
    }
  }
  </script>



// WEBPACK FOOTER //
// src/components/Meetup/Votauth.vue